import type { Box, Camera } from '@os/engine';

/**
 * Pixels the virtual keyboard hides at the bottom of the layout viewport: what the visual viewport (height and
 * scroll) no longer covers. iOS and Android Chrome shrink the visual viewport only, never `innerHeight`.
 */
export function keyboardInset(vv: { height: number; offsetTop: number }, innerHeight: number): number {
  return Math.max(0, Math.round(innerHeight - vv.height - vv.offsetTop));
}

/**
 * The camera that shows `box` (world) between the top of the view and the keyboard, `margin` px clear of both;
 * a box taller than that space keeps its top in view. Same camera (same object) when the box is already visible.
 */
export function revealAboveKeyboard(camera: Camera, box: Box, view: { w: number; h: number }, inset: number, margin = 16): Camera {
  const top = (box.y - camera.y) * camera.z;
  const bottom = (box.y + box.h - camera.y) * camera.z;
  const limit = view.h - inset - margin;
  let dy = bottom > limit ? bottom - limit : 0; // screen px to scroll the content up
  if (top - dy < margin) dy = top - margin;
  if (dy === 0) return camera;
  return { ...camera, y: camera.y + dy / camera.z };
}
